export default "__VITE_ASSET__ed8fe0d4__"